import React, { createContext, useContext, useState, useEffect } from "react";

const viewportContext = createContext({});

export const ViewportProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [screenType, setScreenType] = useState({
    isTab: false,
    isMobile: false,
    isTv: false,
  });

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    // tab screenType
    if (width > 767 && width <= 1025) {
      setScreenType({ isTab: true, isMobile: false, isTv: false });
    }
    // mobile screenType
    else if (width <= 767) {
      setScreenType({ isTab: false, isMobile: true, isTv: false });
    } else if (width >= 2000) {
      setScreenType({ isTab: false, isMobile: false, isTv: true });
    } else {
      setScreenType({ isTab: false, isMobile: false, isTv: false });
    }
  }, [width, height]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  /* Now we are dealing with a context instead of a Hook, so instead
     of returning the width and height we store the values in the
     value of the Provider */
  return (
    <viewportContext.Provider value={{ width, height, screenType }}>
      {children}
    </viewportContext.Provider>
  );
};

/* Rewrite the "useViewport" hook to pull the width and height values
   out of the context instead of calculating them itself */
const useViewport = () => {
  /* We can use the "useContext" Hook to acccess a context from within
       another Hook, remember, Hooks are composable! */
  const { width, height } = React.useContext(viewportContext);
  return { width, height };
};

export { viewportContext, useViewport };
